import React, { useState, useEffect } from "react";

const ImageSection = () => {
  const slides = [
    { id: 1, src: "../img-1.jpg", alt: "Banner 1" },
    { id: 2, src: "../img-2.jpg", alt: "Banner 2" },
    { id: 3, src: "../img-3.jpg", alt: "Banner 3" },
  ];

  const [current, setCurrent] = useState(0);

  // Auto-slide every 3 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 3000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <div className="relative w-full max-h-[400px] overflow-hidden">
      {/* Slides */}
      <div
        className="flex transition-transform duration-700 ease-in-out"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {slides.map((slide) => (
          <img
            key={slide.id}
            src={slide.src}
            alt={slide.alt}
            className="w-full flex-shrink-0 object-cover"
          />
        ))}
      </div>

      {/* Left arrow */}
      <button
        onClick={() =>
          setCurrent(current === 0 ? slides.length - 1 : current - 1)
        }
        className="absolute top-1/2 left-4 -translate-y-1/2 bg-black bg-opacity-40 text-white px-2 py-1 rounded-full"
      >
        ‹
      </button>

      {/* Right arrow */}
      <button
        onClick={() =>
          setCurrent(current === slides.length - 1 ? 0 : current + 1)
        }
        className="absolute top-1/2 right-4 -translate-y-1/2 bg-black bg-opacity-40 text-white px-2 py-1 rounded-full"
      >
        ›
      </button>

      {/* Dots */}
      <div className="absolute bottom-3 w-full flex justify-center space-x-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-3 h-3 rounded-full ${
              current === index ? "bg-orange-500" : "bg-gray-300"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageSection;
